import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 6a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-12","key":"svg-0"}],["path",{"d":"M9 17h6","key":"svg-1"}]]

const IconDeviceIpadHorizontal = createReactComponent('outline', 'device-ipad-horizontal', 'DeviceIpadHorizontal', __iconNode);

export default IconDeviceIpadHorizontal;